import {
  calculateRevenueRowStatus,
  revenueRowStatusColors,
  revenueRowStatusLabels,
} from '@/components/detail/revenue/utils';
import { Badge } from '@/components/ui/badge';
import { toMoneyString } from '@/lib/utils';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  type ApartmentRevenueRow,
  type BrfApartmentRevenueRow,
  type IndustrialPremisesRevenueRow,
  type ModelName,
  type OutdoorSectionRevenueRow,
  type ParkingSpotRevenueRow,
} from '@pigello/pigello-matrix';
import Dot from './dot';
import type { RelationFieldProps } from './types';
import { getConfig } from '@/lib/get-config';
import { baseDebitRowFilters } from '@/app/dashboard/filters';
import type { ExtractStrict } from 'type-fest';

type RevenueRowModelName = ExtractStrict<
  ModelName,
  | 'apartmentrevenuerow'
  | 'parkingspotrevenuerow'
  | 'industrialpremisesrevenuerow'
  | 'outdoorsectionrevenuerow'
  | 'brfapartmentrevenuerow'
>;

type RevenueRow =
  | ApartmentRevenueRow
  | ParkingSpotRevenueRow
  | IndustrialPremisesRevenueRow
  | OutdoorSectionRevenueRow
  | BrfApartmentRevenueRow;

function getRevenueRowConfig(modelName: RevenueRowModelName) {
  return getConfig<RevenueRowModelName, RevenueRow>(modelName);
}

export const RevenueRowItem: (
  modelName: RevenueRowModelName
) => RelationFieldProps<RevenueRow> = (modelName: RevenueRowModelName) => ({
  filters: baseDebitRowFilters,
  nested: getRelationFieldNames(getRevenueRowConfig(modelName)),
  renderItem: (item) => {
    const status = calculateRevenueRowStatus(item);

    return {
      title: (
        <>
          {item?.title}{' '}
          <Badge variant={revenueRowStatusColors[status]}>
            {revenueRowStatusLabels[status]}
          </Badge>
        </>
      ),
      descriptionItems: (
        <div className='flex items-center'>
          <span className='font-medium'>
            {toMoneyString(item.unitAmount * (item?.unitPrice ?? 0))}/mån
          </span>
          <Dot />
          <span className='font-medium'>
            {item.startDate ?? 'Från avtalets början'} -{' '}
            {item.endDate ?? 'Tillsvidare'}
          </span>
          <Dot />
          <span className='font-medium'>{item.article?.name}</span>
        </div>
      ),
    };
  },
});
